import { Dimensions, StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getDynamicScrollListStyles = (props, flatListWidth) => {
  var _a;
  var tabs = props.tabs,
    _props$separatorSpace = props.separatorSpace,
    separatorSpace = _props$separatorSpace === void 0 ? 2 : _props$separatorSpace,
    _props$seekGap = props.seekGap,
    seekGap = _props$seekGap === void 0 ? 0 : _props$seekGap,
    _props$numberOfColumn = props.numberOfColumn,
    numberOfColumn = _props$numberOfColumn === void 0 ? 1 : _props$numberOfColumn,
    _props$startEndSeekGa = props.startEndSeekGap,
    startEndSeekGap = _props$startEndSeekGa === void 0 ? 0 : _props$startEndSeekGa,
    _props$tabsHeaderTopO = props.tabsHeaderTopOffset,
    tabsHeaderTopOffset = _props$tabsHeaderTopO === void 0 ? 0 : _props$tabsHeaderTopO;
  var width = flatListWidth / numberOfColumn - separatorSpace - (seekGap + startEndSeekGap) / numberOfColumn;
  var hasTabs = ((_a = tabs === null || tabs === void 0 ? void 0 : tabs.data) === null || _a === void 0 ? void 0 : _a.length) > 0;
  var containerHeight = Dimensions.get('window').height - tabsHeaderTopOffset;
  var _tokens$spacing = tokens.spacing,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_16 = _tokens$spacing.SPACING_16;
  return StyleSheet.create({
    container: Object.assign({}, hasTabs && {
      height: containerHeight
    }),
    contentContainer: Object.assign({}, !!seekGap && {
      paddingHorizontal: startEndSeekGap
    }),
    singleListItemWidth: {
      width: width
    },
    ctaOnContainer: {
      paddingTop: SPACING_8,
      paddingBottom: SPACING_12,
      paddingHorizontal: SPACING_16
    },
    listContainer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row'
    },
    listHeaderTitle: {
      marginHorizontal: tokens.spacing.SPACING_20,
      marginTop: tokens.spacing.SPACING_12
    }
  });
};